"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _context = require("../context");
var _utils = require("../utils");
var _TextCSS = require("./TextCSS");
var _constants = require("./constants");
var _propTypes = require("./propTypes");
var _utils2 = require("./utils");
const TextWithoutDocs = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(_constants.textPropsToFilter)
})(_ref => {
  let {
    variant,
    fontSize: fontSizeProp,
    lineHeight: lineHeightProp,
    ...props
  } = _ref;
  // Both variant and font size prop override the default font size
  let fontSize = fontSizeProp;
  let lineHeight = lineHeightProp;
  if (!variant && !fontSizeProp) {
    fontSize = _constants.DEFAULT_FONT_SIZE;
  }

  //legacy font-size will decide both font-size and line-height
  if (!variant && !(0, _utils2.isLegacyFontSize)(fontSize) && !lineHeightProp) {
    lineHeight = _constants.DEFAULT_LINE_HEIGHT;
  }
  const forwardedProps = {
    variant,
    fontSize,
    lineHeight,
    ...props
  };
  return props.theme.shouldUseResponsiveText && !props.shouldUseFixedFontStyle ? (0, _TextCSS.responsiveTextCSS)(forwardedProps) : (0, _TextCSS.textCSS)(forwardedProps);
});

// shouldForwardProp is stored in this property and combined with the shouldForwardProp
// definition of any components which use styled(Text). This means that those outer
// components will be unable to use any props from Text, because they won't be forwarded
// from the outer component to the inner Text.
// To prevent this, explicitly override the property to trick emotion into thinking that
// Text doesn't use shouldForwardProp when doing styled(Text).
// This doesn't affect the Text component itself (the props won't be forwarded to the DOM).
// https://github.com/emotion-js/emotion/blob/97673098945a75b716d4cac100c1af46a5ae18f2/packages/styled-base/src/index.js#L35-L41
TextWithoutDocs.__emotion_forwardProp = undefined;
const TextWithDocs = (0, _stencilReactDesc.describe)(TextWithoutDocs).description('Text styled to match Stencil typography rules.');
TextWithDocs.propTypes = {
  ..._propTypes.textPropTypes
};
TextWithDocs.defaultProps = {
  ..._constants.defaultProps
};
const Text = (0, _utils.withTestAttributes)({
  component: 'StencilText'
})(TextWithDocs);
Text.displayName = 'Text';
var _default = exports.default = Text;